/**
 * Async Script Loader
 *
 * Dynamically loads external JavaScript files (e.g. gateway SDKs, Risk.js).
 * Portable — uses only standard DOM APIs.
 */

/**
 * Load an external script asynchronously.
 *
 * @param scriptURL - URL of the script to load
 * @param existingVariable - If truthy, resolves immediately (script already loaded)
 * @param integrity - Optional SRI integrity hash
 * @returns Promise that resolves when the script is loaded
 */
export const asyncLoadScript = (
  scriptURL: string,
  existingVariable?: unknown,
  integrity?: string
): Promise<void> => new Promise((resolve, reject) => {
  if (existingVariable) {
    resolve();
    return;
  }

  const script = document.createElement('script');
  script.src = scriptURL;
  script.async = true;

  if (integrity) {
    script.integrity = integrity;
    script.crossOrigin = 'anonymous';
  }

  script.onload = () => resolve();
  script.onerror = (error) => reject(error);
  document.body.appendChild(script);
});
